"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInput = exports.SelectorInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
const lodash_1 = require("lodash");
exports.SelectorInput = styled_components_1.default.input `
  padding: 5px;
  flex-grow: 1;
  border: 1px solid
    ${(p) => (p.disabled ? theme_1.theme.colors.grey(3) : theme_1.theme.colors.grey(3))};
  border-radius: 4px;
  height: 40px;
  ${theme_1.theme.fontSize(-1)};
  color: ${(p) => (p.disabled ? theme_1.theme.colors.grey(2) : theme_1.theme.colors.blackText)};
  background-color: ${(p) => p.disabled ? theme_1.theme.colors.grey(4) : theme_1.theme.colors.white};
`;
const NumberInput = (props) => {
    const { disabled, min, max, step, isFloat, value, onChange, debounceTime, allowEmpty = false, } = props;
    const [textContent, setTextContent] = (0, react_1.useState)(value ?? undefined);
    const [hasInteracted, setHasInteracted] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (value === null || value === undefined) {
            setTextContent("");
        }
        else if (Number(value) !== Number(textContent)) {
            setTextContent(value);
        }
    }, [value]);
    const sendChange = (0, react_1.useCallback)((0, lodash_1.debounce)((value) => {
        if (onChange) {
            onChange(value);
        }
    }, debounceTime ?? 1000), [debounceTime]);
    const onTextEdited = (0, react_1.useCallback)((text) => {
        const normalizedText = text?.replace(/,/g, ".");
        setHasInteracted(true);
        if (normalizedText === "" || normalizedText === undefined) {
            setTextContent("");
            sendChange(null);
        }
        else {
            const numberValue = isFloat
                ? parseFloat(normalizedText)
                : parseInt(normalizedText, 10);
            setTextContent(isNaN(numberValue) ? "" : numberValue);
            if (!isNaN(numberValue)) {
                sendChange(numberValue);
            }
            else {
                sendChange(null);
            }
        }
    }, [isFloat]);
    const showEmptyMessage = !allowEmpty && hasInteracted && textContent === "";
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(exports.SelectorInput, { value: textContent, type: "number", onChange: (e) => onTextEdited(e.target.value), disabled: disabled, min: min, step: step, max: max }), showEmptyMessage && ((0, jsx_runtime_1.jsx)("div", { style: { color: theme_1.theme.colors.red, marginTop: "4px" }, children: "This field cannot be empty." }))] }));
};
exports.NumberInput = NumberInput;
